export const charCap = (string: string | null, limit: number) => {
  if (string === null) return null
  if (string.length <= limit) return string
  return string.substring(0, limit) + '...'
}
